import { render } from "./UserGroupList.vue?vue&type=template&id=4f59508e&scoped=true"
import script from "./UserGroupList.vue?vue&type=script&lang=js"
export * from "./UserGroupList.vue?vue&type=script&lang=js"

import "./UserGroupList.vue?vue&type=style&index=0&id=4f59508e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f59508e"]])

export default __exports__